import { z } from 'zod';

export const PinValidateSchema = z.object({
  pin: z.string().min(15, "El pin debe tener al menos 15 caracteres").max(20, "El pin debe tener máximo 20 caracteres").regex(/^[a-zA-Z0-9]*$/, "El pin debe contener solo caracteres alfanuméricos")
});

export const PinValidateResponseSchema = z.object({
  status: z.number().optional(),
  message: z.string().optional(),
  data: z.coerce.number()
});

export const RedeemCodeParamSchema = z.object({
  code: z.string().trim().min(1, "El código redimible es requerido"),
});


export const ValidateCertResponseSchema = z.object({
  status: z.union([z.literal(200), z.literal(500)]),
  message: z.string(),
  data: z.object({
    ALFILER: z.string().optional(),
    'Oficina de Registro': z.string().optional(),
    Matricula: z.string().optional(),
    Mensaje: z.string().optional(),
    'Fecha Transaccion': z.string().optional(),
    'Inicio Generacion': z.string().optional(),
    'Finalizacion Generacion': z.string().optional(),
    pdfExist: z.boolean().optional(),
    pdfLink: z.string().optional(),
    base64: z.string().optional(),
    nameFile: z.string().optional(),
  }),
});

export type PinValidate = z.infer<typeof PinValidateSchema>;
export type PinValidateResponse = z.infer<typeof PinValidateResponseSchema>;
export type ValidateCertResponse = z.infer<typeof ValidateCertResponseSchema>;
export type RedeemCodeParam = z.infer<typeof RedeemCodeParamSchema>;

